import React, { useEffect, useState } from "react";
import { CheckIcon, KeyIcon } from "@heroicons/react/solid";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  InputGroup,
  Modal,
  Table,
  FormCheck,
  ToastContainer,
} from "react-bootstrap";
import Select from "react-select";
import CopyToClipboard from "react-copy-to-clipboard";
import { XCircleIcon } from "@heroicons/react/outline";
import {
  useCheckUserDetailsMutation,
  useUserDropDownMutation,
  useAccountRegisterMutation,
  useGetRoutesOfEAMutation,
  useGetEUforEAMutation,
  useCountriesOptionsMutation,
} from "Services/services";
import "react-phone-input-2/lib/style.css";
import { Toast } from "react-bootstrap";

// import { UserOnboardingListTable } from "./Tables";
import { MdOutlineAutoMode } from "react-icons/md";
import { Routes } from "routes";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaCircleInfo } from "react-icons/fa6";
import { useHistory } from "react-router-dom";

export default () => {
  const history = useHistory();

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");

  const [users, setUsers] = useState([]);
  const [user, setUser] = useState(null);
  const [entUserOptions, setEntUserOptions] = useState([]);
  const [entUser, setEntUser] = useState(null);
  const [enterpriseName, setEnterpriseName] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState("");
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  // const [channel, setChannel] = useState("sms");
  const [routesOfEnt, setRoutesOfEnt] = useState({
    value: "",
    label: "Select Route",
  });
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [account, setAccount] = useState("smpp");
  // const sessionOptions = [
  //   { value: "tx", label: "TX" },
  //   { value: "rx", label: "RX" },
  //   { value: "trx", label: "TRX" },
  // ];
  // const [session, setSession] = useState();
  const [tps, setTps] = useState('');
  const [ipParts, setIpParts] = useState(["", "", "", ""]);
  const [dltType, setDltType] = useState(null);
  const dltTypeOptions = [
    { value: "", label: "None" },
    { value: "default", label: "Default" },
    { value: "whitelisted", label: "Whitelisted" },
  ];
  const [validationError, setValidationError] = useState({
    enterprise: false,
    entUser: false,
    dept: false,
    password: false,
    route: false,
    account: false,
    tps: false,
    ip: false,
    dltType: false,
  });


  const [showDefault, setShowDefault] = useState(false);

  const [copied, setCopied] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [getCountries] = useCountriesOptionsMutation();
  const [userOnboard] = useAccountRegisterMutation();
  const [verify] = useCheckUserDetailsMutation();
  const [refreshTable, setRefreshTable] = useState(false);
  const [validated, setValidated] = useState(false);


  // Get the usertype from localStorage
  const loggedUserData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(loggedUserData);
  const loggedUserType = userObject.user_type;

  // const [cost, setCost] = useState();
  // const [dltCost, setDltCost] = useState();
  // const [refund, setRefund] = useState();

  // const serviceTypeOptions = [
  //   { value: "transactional", label: "Transactional" },
  //   { value: "professional", label: "Professional" },
  //   { value: "any", label: "Any" },
  // ];
  // const [serviceType, setServiceType] = useState();


  // const channelOptions = [
  //   { value: "sms", label: "SMS" },
  //   { value: "whatsapp", label: "Whatsapp" },
  // ];

  const [userDropDown] = useUserDropDownMutation();

  useEffect(() => {
    if (loggedUserType !== "enterprise") {
      fetchUserDropdown();
    }
    fetchCountries();

    // fetchUserTypeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user?.value || loggedUserType === "enterprise") {
      fetchEUOfEA();
      fetchRoutesOfEA();
    }
    // eslint-disable-next-line
  }, [user, loggedUserType]);

  const fetchCountries = async () => {
    try {
      const response = await getCountries({ cname: "" });
      if (response?.data?.statusCode === 200) {
        const options = response.data.data.countries.map((item) => ({
          value: item.name,
          label: `${item.name} (${item.dialCode}) `,
        }));
        setCountryOptions(options);
      } else if (response.data.error) {
        console.error("API returned an error:", response.data.msg);
        setCountryOptions([]);
      }
    } catch (error) {
      setCountryOptions([]);
      console.error("Error fetching country data:", error);
    }
  };

  const fetchUserDropdown = async () => {
    userDropDown({ user_type: "4" })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          const userOptions = response.data.data.user_details.map((user) => ({
            value: user.id,
            label: user.user_name,
          }));
          setUsers(userOptions);
        } else {
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        console.error("Error fetching user data", error);
      });
  };

  const [fetchEU] = useGetEUforEAMutation();
  const fetchEUOfEA = async () => {
    setEntUser(null);
    try {
      const response = await fetchEU({
        user_id: loggedUserType === "enterprise" ? userObject.id : user.value,
      });
      if (response?.data?.statusCode === 200) {
        const options = response.data.data.dropDownData.map((user) => ({
          value: user.id,
          label: `${user.user_name} (${user.email})`,
        }));
        setEntUserOptions(options);
      } else {
        setEntUserOptions([]);
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      setEntUserOptions([]);
      console.error("Error fetching user data", error);
    }
  };

  const [routesOfEA] = useGetRoutesOfEAMutation();
  const fetchRoutesOfEA = async () => {
    setSelectedRoute(null);
    try {
      const response = await routesOfEA({
        user_id: loggedUserType === "enterprise" ? userObject.id : user.value,
      });
      if (response?.data?.statusCode === 200) {
        const options = response.data.data.finalRouteData.map((user) => ({
          value: user.id,
          label: user.route_name,
        }));
        setRoutesOfEnt(options);
      } else {
        setRoutesOfEnt([]);
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      setRoutesOfEnt([]);
      console.error("Error fetching user data", error);
    }
  };

  const RequiredLabel = ({ label }) => (
    <Form.Label>
      {label}
      <span className="text-danger"> * </span>
    </Form.Label>
  );

  const generatePassword = () => {
    const length = 12;
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const symbols = "@$!%*?&#^";
  
    const all = lower + upper + numbers + symbols;
  
    let password = "";
    password += lower[Math.floor(Math.random() * lower.length)];
    password += upper[Math.floor(Math.random() * upper.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += symbols[Math.floor(Math.random() * symbols.length)];
  
    for (let i = 4; i < length; i++) {
      password += all[Math.floor(Math.random() * all.length)];
    }
  
    // Shuffle password to remove predictable pattern
    password = password
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");
  
    setPassword(password);
    setValidationError((prev) => ({
      ...prev,
      password: false,
    }));
  };
  
  const [isVerifiedUsername, setisVerifiedUsername] = useState();

  const verifyUsername = (e) => {
    const username = e.target.value;
    setEnterpriseName(username);

    const regex = /^[a-zA-Z0-9]+$/;

    if (username.length >= 2 && username.length <= 8 && regex.test(username)) {
      const postData = { data: username };
      verify(postData)
        .then((success) => {
          if (success?.data?.statusCode === 200) {
            setisVerifiedUsername(true);
            setValidationError((prev) => ({ ...prev, system: false }));
          } else if (success?.data?.statusCode > 300) {
            setisVerifiedUsername(false);
            console.error("Verification failed");
          }
        })
        .catch((error) => {
          setisVerifiedUsername(false);
          console.error("Verification failed", error);
        });
    } else {
      setisVerifiedUsername(false);
      setValidationError((prev) => ({ ...prev, system: true }));
    }
  };

  const handleAccountChange = (event) => {
    setAccount(event.target.value);
    setValidationError((prev) => ({ ...prev, account: false }));
  };
  const handleIPChange = (index, value) => {
    const num = value.replace(/\D/g, ""); // only digits
    if (num <= 255) {
      const updated = [...ipParts];
      updated[index] = num;
      setIpParts(updated);

      // Validate IP after update
      const ip = updated.join(".");
      const ipv4Regex =
        /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
      if (ipv4Regex.test(ip)) {
        setValidationError((prev) => ({ ...prev, ip: false }));
      } else {
        setValidationError((prev) => ({ ...prev, ip: true }));
      }
    }
  };

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handleClose = () => {
    setShowDefault(false);
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    let haserror = false;
    if (loggedUserType !== "enterprise" && (!user || !user.value)) {
      setValidationError((prev) => ({ ...prev, enterprise: true }));
      haserror = true;
    }

    if (!entUser || !entUser.value) {
      setValidationError((prev) => ({ ...prev, entUser: true }));
      haserror = true;
    }

    if (!enterpriseName) {
      setValidationError((prev) => ({ ...prev, system: true }));
      haserror = true;
    }

    // if (!name) {
    //   setValidationError((prev) => ({ ...prev, dept: true }));
    //   haserror = true;
    // }

    if (!selectedCountry || !selectedCountry?.value) {
      setValidationError((prev) => ({ ...prev, country: true }));
      haserror = true;
    }

    if (!password) {
      setValidationError((prev) => ({ ...prev, password: true }));
      haserror = true;
    }

    if (!selectedRoute) {
      setValidationError((prev) => ({ ...prev, route: true }));
      haserror = true;
    }

    if (!account) {
      setValidationError((prev) => ({ ...prev, account: true }));
      haserror = true;
    }

    if (!tps) {
      setValidationError((prev) => ({ ...prev, tps: true }));
      haserror = true;
    }

    if (haserror) {
      setValidated(true);
      return;
    } else {
      setValidated(true);
      setShowDefault(true);
    }
  };

  // const handleEditSubmit = (e) => {
  //   e.preventDefault();
  //   setShowEdit(false);
  //   setShowEditDefault(true);
  // }

  // console.log('ent', userType);
  const userData = {
    system_id: enterpriseName || "",
    password: password || "",
    throughput: tps || "0.0",
    default_smsc: "",
    default_cost: "0.0",
    enable_prepaid_billing: 1,
    credit: 0,
    callback_url: "",
    callback_method: "GET",
    callback_body: "",
    simulate: 0,
    simulate_deliver_every: 0,
    simulate_temporary_failure_every: 0,
    simulate_permanent_failure_every: 0,
    simulate_mo_every: 0,
    max_binds: 10,
    connect_allow_ip: ipParts.join(".") || "",
    dlt: dltType?.value || "",
    reroute: 0,
    spam: "00",
    coordinator: "0",
    user: "userchain",
    user_id: entUser?.value,
    hlr_lookup: 0,
    active: "ACTIVE",
    sender_type: "ANY",
    channel: account || "",
    dlt_cost: "0.0",
    refund_amount: "0.0",
    department_name: name || "",
    parent: userObject.user_chain,
    created_by: userObject.id,
    route: selectedRoute?.label || "",
    smsc_type: "international", //domestic||international
    country: selectedCountry?.value,

    enterprise_name:
      loggedUserType === "enterprise" ? userObject.id : user?.label,
    // "enterprise_user": entUser?.value,
    account_type: account || "",
    // session: session?.value || "",
    ip: ipParts.join(".") || "",
    receiver: "00",
    senderid: "00",
    contentid: "00",
  };

  const submitForm = (e) => {
    e.preventDefault();
    userOnboard(userData)
      .then((success) => {
        if (success?.data?.statusCode === 200) {
          handleClose();
          setToastMessage(success?.data?.message || "Account created successfully!");
          setToastVariant("success");
          setRefreshTable(!refreshTable);
          setEnterpriseName("");
          setName("");
          setPassword("");
          setisVerifiedUsername("");
          setTimeout(() => {
            history.push(Routes.SMSSMPPAccount.path);
          }, 2000);
        }
        if (success?.data?.statusCode === 500) {
          handleClose();
          setToastMessage(success.data.message || "Upload failed!");
          setToastVariant("danger");
        } else if (success?.data?.statusCode > 300) {
          handleClose();
          setToastMessage("Upload failed!");
          setToastVariant("danger");
          setRefreshTable(!refreshTable);
        }
        setShowToast(true);
      })
      .catch((error) => {
        handleClose();
        setRefreshTable(!refreshTable);
        setToastMessage("Upload failed!");
        setToastVariant("danger");
        setShowToast(true);
      });
  };


  // const [passwordError, setPasswordError] = useState("");

  // const submitEditForm = (e) => {
  //   e.preventDefault();

  //   // Password validation: Add your custom validation logic here
  //   if (editDetails.password === "" || editDetails?.password?.length < 8) {
  //     setPasswordError("Password must be at least 8 characters long.");
  //     return; // Prevent form submission if the validation fails
  //   }

  //   // Clear any previous error if password is valid
  //   setPasswordError("");

  //   // Continue with API call if password validation passes
  //   userDetailUpdates(userEditData)
  //     .then((success) => {
  //       if (success?.data?.statusCode === 200) {
  //         setShowDefault(false);
  //         setShowEdit(false);
  //         setShowEditDefault(false);
  //         setEditDetails([]);
  //         setRefreshTable(!refreshTable);
  //         setPhone("");
  //       } else if (success?.data?.statusCode > 300) {
  //         setShowDefault(false);
  //         setShowEdit(false);
  //         setShowEditDefault(false);
  //         setEditDetails([]);
  //         setRefreshTable(!refreshTable);
  //       }
  //     })
  //     .catch((error) => {
  //       setShowDefault(false);
  //       setShowEdit(false);
  //       setShowEditDefault(false);
  //       setEditDetails([]);
  //       setRefreshTable(!refreshTable);
  //       console.error("Error updating user details", error);
  //     });
  // };

  // const selectUserType = (selectedOption) => {
  //   setUserType(selectedOption);
  //   setCrmValue(selectedOption.value);
  // };

  // const handleEdit = async (userDetails) => {
  //   try {
  //     const response = await crmData({ user_type: 3 });
  //     if (response?.data?.statusCode === 200) {
  //       const options = response.data.data.user_details.map(user => ({
  //         value: user.id,
  //         label: `${user.user_name} (${user.email})`
  //       }));

  //       setSelectedCrmEditOptions([
  //         { value: userDetails.customer_relation_manager, label: userDetails.customer_relation_manager_name },
  //         ...options
  //       ]);
  //     } else {
  //       console.error('Failed to fetch user data', response.data);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching user data', error);
  //   } finally {
  //   }

  //   setEditDetails(userDetails);
  //   setShowEdit(true);
  // };

  // const handleUserTypeChange = (selectedOption) => {
  //   setUserType(selectedOption);
  //   setValidationError(false); // Clear error on valid selection
  //   selectUserType(selectedOption);
  // };

  // const [selectedOptions, setSelectedOptions] = useState({
  //   spam: [], // Can now store ["global"], ["user"], or ["global", "user"]
  //   receiver: [],
  //   sender: [],
  //   content: [],
  // });

  // const handleCheckboxChange = (group, value) => {
  //   setSelectedOptions((prevState) => {
  //     const currentSelections = prevState[group];

  //     // If the value is already selected, remove it; otherwise, add it
  //     if (currentSelections.includes(value)) {
  //       return {
  //         ...prevState,
  //         [group]: currentSelections.filter((item) => item !== value),
  //       };
  //     } else {
  //       return {
  //         ...prevState,
  //         [group]: [...currentSelections, value],
  //       };
  //     }
  //   });
  // };

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <Card border={1} className="mb-3">
        <Card.Body className="p-0">
          <h5 className="mb-4">Add Account</h5>
          <Form onSubmit={(e) => handleSubmit(e)} autoComplete="off" noValidate validated={validated}>
            <input
              type="text"
              name="preventAutoFill"
              style={{ display: "none" }}
            />
            <Row>
              {loggedUserType !== "enterprise" && (
                <Col md={6} lg={4} className="mb-3">
                  <Form.Group id="userType">
                    <RequiredLabel label="Enterprise Name" />
                    <Select
                      options={users}
                      placeholder="Select User"
                      className="mb-0"
                      isSearchable={true}
                      value={user || ''}
                      onChange={(selectedOption) => {
                        setUser(selectedOption);
                        setValidationError((prev) => ({
                          ...prev,
                          enterprise: false,
                        }));
                        // selectUserType(selectedOption);
                      }}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          borderColor: validated && !user ? '#dc3545' : validated && user ? '#65BB82': provided.borderColor,
                          borderRadius: '0.75rem',
                        }),
                      }}
                    />
                    {validationError.enterprise && (
                      <div className="invalid-feedback d-block">
                        Enterprise Name is required.
                      </div>
                    )}
                  </Form.Group>
                </Col>
              )}
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="entUser">
                  <RequiredLabel label="Enterprise User" />
                  <Select
                    options={entUserOptions}
                    placeholder="Select User"
                    className="mb-0"
                    isSearchable={true}
                    value={entUser || ''}
                    onChange={(selectedOption) => {
                      setEntUser(selectedOption);
                      setValidationError((prev) => ({
                        ...prev,
                        entUser: false,
                      }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: validated && !entUser ? '#dc3545' : validated && entUser ? '#65BB82': provided.borderColor,
                        borderRadius: '0.75rem',
                      }),
                    }}
                  />
                  {validationError.entUser && (
                    <div className="invalid-feedback d-block">
                      Enterprise User is required.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="systemId">
                  <RequiredLabel label="System ID" />
                  <InputGroup>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Enter System ID"
                      value={enterpriseName}
                      onChange={verifyUsername}
                      // pattern="^[a-zA-Z0-9]+$"
                      minLength={2}
                      maxLength={8}
                      title="This must be alphanumeric with 2-8 characters, no spaces."
                      autoComplete="new-username"
                    />
                    {isVerifiedUsername && (
                      <InputGroup.Text title="System ID is available and unique">
                        <CheckIcon width={20} className="text-success" />
                      </InputGroup.Text>
                    )}
                    {isVerifiedUsername === false && (
                      <InputGroup.Text title="System ID is not available or unique">
                        <XCircleIcon width={20} className="text-danger"/>
                      </InputGroup.Text>
                    )}
                    {validationError.system && (
                      <div className="invalid-feedback d-block">
                        Enter a valid System ID.
                      </div>
                    )}
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="country">
                <RequiredLabel label="Country" />
                  <Select
                    options={countryOptions}
                    placeholder="Select Country"
                    className={`mb-0 ${
                      validationError.country ? "is-invalid-select" : ""
                    }`}
                    isSearchable={true}
                    value={selectedCountry || ''}
                    onChange={(option) => {
                      setSelectedCountry(option);
                      setValidationError((prev) => ({
                        ...prev,
                        country: false,
                      }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: validated && !selectedCountry ? '#dc3545' : validated && selectedCountry ? '#65BB82': provided.borderColor,
                        borderRadius: '0.75rem',
                      }),
                    }}
                    autoComplete="new-country"
                    title="Select the country where this user will operate"
                  />
                  {validationError.country && (
                    <div className="invalid-feedback d-block">
                      Country is required.
                    </div>
                  )}
                </Form.Group>
              </Col>
             
          
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="password">
                <Form.Label className="d-flex align-items-center gap-1">
                <span>Password</span>
                <span className="text-danger"> * </span>
                  <OverlayTrigger
                        placement="right"
                        overlay={
                          <Tooltip id="ip-tooltip">
                            Password must be 8-32 characters, include uppercase, lowercase, number, and special character.
                          </Tooltip>
                        }
                      >
                        <span
                          className="ms-1 text-primary"
                          style={{ cursor: "pointer" }}
                        >
                          <FaCircleInfo size={18} />
                        </span>
                      </OverlayTrigger>
                  </Form.Label>

                  <InputGroup>
                    <InputGroup.Text>
                      <KeyIcon width={20} />
                    </InputGroup.Text>
                    <Form.Control
                      required
                      type="password"
                      placeholder="Password"
                      value={password}
                      title="Password must be 8-32 characters, include uppercase, lowercase, number, and special character."
                      onChange={(e) => {
                        const newValue = e.target.value;
                        // Limit length and allow valid characters
                        if (newValue.length <= 32) {
                          setPassword(newValue);
                        
                          // Validate live feedback
                          const isValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{0,32}$/.test(newValue);
                          setValidationError((prev) => ({
                            ...prev,
                            password: !isValid,
                          }));
                        }
                      }}
                      maxLength={32}
                      minLength={8}
                      autoComplete="new-password"
                    />
                    <InputGroup.Text>
                      <MdOutlineAutoMode
                        size={20}
                        onClick={generatePassword}
                        style={{ cursor: "pointer" }}
                        title="Auto-generate password"
                      />
                    </InputGroup.Text>
                  </InputGroup>
                  {validationError.password && (
                    <div className="invalid-feedback d-block">
                      Enter a valid strong password.
                    </div>
                  )}
                </Form.Group>
              </Col>
              {/* <Col md={6} lg={4} className="mb-3">
                <Form.Group id="channel">
                  <Form.Label>Channel</Form.Label>
                  <Select
                      options={channelOptions}
                      placeholder="Select Channel"
                      className="mb-0"
                      isSearchable={true}
                      defaultValue={channel}
                      onChange={setChannel}
                    />
                  <Form.Control
                    disabled
                    type="text"
                    placeholder="Channel"
                    defaultValue={channel}
                  />
                </Form.Group>
              </Col> */}
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="userType">
                  <RequiredLabel label="Route" />
                  <Select
                    options={routesOfEnt}
                    placeholder="Select Route"
                    className="mb-0"
                    value={selectedRoute || ''}
                    onChange={(value) => {
                      setSelectedRoute(value);
                      setValidationError((prev) => ({
                        ...prev,
                        route: false,
                      }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: validated && !selectedRoute ? '#dc3545' : validated && selectedRoute ? '#65BB82': '#ced4da',
                        borderRadius: '0.75rem',
                      }),
                    }}
                  />
                  {validationError.route && (
                    <div className="invalid-feedback d-block">
                      Route is required.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="accountTypeOptions">
                  <RequiredLabel label="Account Type" />
                  {/* <div className="d-flex flex-wrap justify-content-around"> */}
                  <div className="d-flex flex-wrap justify-content-start">
                    <Form.Check
                      type="radio"
                      id="smpp"
                      label="SMPP"
                      name="accountTypeOptions"
                      value="smpp"
                      className="me-3"
                      onChange={handleAccountChange}
                      checked={account === "smpp"}
                    />
                    {/* <Form.Check
                        type="radio"
                        id="web"
                        label="WEB"
                        name="accountTypeOptions"
                        value="web"
                        className="me-3"
                        onChange={handleRouteChange}
                        checked={selectedRoute === "web"}
                      />
                      <Form.Check
                        type="radio"
                        id="http"
                        label="HTTP"
                        name="accountTypeOptions"
                        value="http"
                        onChange={handleRouteChange}
                        checked={selectedRoute === "http"}
                      />
                      <Form.Check
                        type="radio"
                        id="whatsapp"
                        label="WHATSAPP"
                        name="accountTypeOptions"
                        value="whatsapp"
                        onChange={handleRouteChange}
                        checked={selectedRoute === "whatsapp"}
                      />
                      <Form.Check
                        type="radio"
                        id="rcs"
                        label="RCS"
                        name="accountTypeOptions"
                        value="rcs"
                        onChange={handleRouteChange}
                        checked={selectedRoute === "rcs"}
                      /> */}
                  </div>
                  {validationError.account && (
                    <div className="invalid-feedback d-block">
                      Account Type is required.
                    </div>
                  )}
                </Form.Group>
              </Col>
              {/* <Col md={6} lg={4} className="mb-3">
                <Form.Group id="session">
                  <RequiredLabel label="Session" />
                  <Select
                    options={sessionOptions}
                    placeholder="Select Session"
                    className="mb-0"
                    isSearchable={true}
                    value={session}
                    onChange={(val) => {
                      setSession(val);
                      setValidationError((prev) => ({
                        ...prev,
                        session: false,
                      }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: validated && !session ? '#dc3545' :  validated && session ? '#65BB82': provided.borderColor,
                        borderRadius: '0.75rem',
                      }),
                    }}
                  />
                  {validationError.session && (
                    <div className="invalid-feedback d-block">
                      Session is required.
                    </div>
                  )}
                </Form.Group>
              </Col> */}
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="tps">
                  <RequiredLabel label="TPS" />
                  <Form.Control
                  required
                    type="text"
                    placeholder="Enter TPS"
                    value={tps}
                    className="mb-0"
                    pattern="^\d{1,4}$"
                    minLength={1}
                    maxLength={4}
                    onChange={(e) => {
                      const val = e.target.value;
                      setTps(val);
                      if (/^\d{1,4}$/.test(val)) {
                        setValidationError((prev) => ({
                          ...prev,
                          tps: false,
                        }));
                      }
                    }}
                    title="TPS must be a 1-4 digit positive number"
                    autoComplete="new-tps"
                  />
                  {validationError.tps && (
                    <div className="invalid-feedback d-block">
                      TPS is required.
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="name">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Remarks"
                    value={name}
                    pattern="^[a-zA-Z0-9]{0,50}$"
                    minLength={3}
                    onChange={(e) => {
                      if (/^[a-zA-Z0-9]{0,50}$/.test(e.target.value))
                        setName(e.target.value);
                    }}
                    title="This must be alphanumeric with maximum 50 characters, no spaces."
                    autoComplete="new-name"
                  />
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="ip">
                  <Form.Label className="d-flex align-items-center gap-1 mb-1">
                    <span>IP Address</span>
                    <span
                      className="d-flex align-items-center"
                      style={{ fontSize: "0.75rem" }}
                    >
                      {/* <span style={{ color: 'red' }}>*</span> */}
                      <OverlayTrigger
                        placement="right"
                        overlay={
                          <Tooltip id="ip-tooltip">
                            Enter a valid IPv4 address in four parts (e.g.
                            192.168.0.1)
                          </Tooltip>
                        }
                      >
                        <span
                          className="ms-1 text-primary"
                          style={{ cursor: "pointer" }}
                        >
                          <FaCircleInfo size={18} />
                        </span>
                      </OverlayTrigger>
                    </span>
                  </Form.Label>

                  <div className="d-flex gap-2">
                    {[0, 1, 2, 3].map((index) => (
                      <Form.Control
                        key={index}
                        type="text"
                        value={ipParts[index] || ""}
                        onChange={(e) => handleIPChange(index, e.target.value)}
                        maxLength="3"
                        style={{ width: "60px", textAlign: "center" }}
                        autoComplete={`ip-segment-${index}`}
                      />
                    ))}
                  </div>
                  {validationError.ip && (
                    <div className="invalid-feedback d-block">
                      Enter a valid IP address.
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="dltTypeLabel">
                  <Form.Label>DLT Type</Form.Label>
                  <Select
                    options={dltTypeOptions}
                    placeholder="Select DLT-Type"
                    className="mb-0"
                    isSearchable={true}
                    value={dltType || ''}
                    onChange={(val) => {
                      setDltType(val);
                      // setValidationError((prev) => ({
                      //   ...prev,
                      //   dltType: false,
                      // }));
                    }}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: validated && !dltType ? '#65BB82' :  validated && dltType ? '#65BB82': provided.borderColor,
                        borderRadius: '0.75rem',
                      }),
                    }}
                  />
                  {/* {validationError.dltType && (
                      <div className="invalid-feedback d-block">
                        DLT Type is required.
                      </div>
                    )} */}
                </Form.Group>
              </Col>
            </Row>
            <div className="m-3 d-flex">
            <Button variant="secondary" className="my-3 ms-auto" type="submit">
              Preview
            </Button>
            </div>
            {/* <Card.Body>
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mb-4">Commercial</h5>
              </div>
              <input type="text" name="preventAutoFill" style={{ display: 'none' }} />
              <Row>
                <Col md={6} lg={4} className="mb-3">
                  <Form.Group id="cost">
                    <Form.Label>Cost</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Enter cost"
                      value={cost}
                      onChange={(e) => {
                        const val = e.target.value;
                        // Allow only numbers with up to two decimal places
                        if (val === '' || /^\d+(\.\d{0,2})?$/.test(val)) {
                          setCost(val);
                        }
                      }}
                      autoComplete="new-cost"
                    />
                  </Form.Group>
                </Col>

                <Col md={6} lg={4} className="mb-3">
                  <Form.Group id="dltCost">
                    <Form.Label>DLT Cost</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Enter DLT Cost"
                      value={dltCost}
                      onChange={(e) => {
                        const val = e.target.value;
                        // Allow only numbers with up to two decimal places
                        if (val === '' || /^\d+(\.\d{0,2})?$/.test(val)) {
                          setDltCost(val);
                        }
                      }}
                      autoComplete="new-dltCost"
                    />
                  </Form.Group>
                </Col>
                <Col md={6} lg={4} className="mb-3">
                  <Form.Group id="refund">
                    <Form.Label>Refund</Form.Label>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Enter Refund Amount"
                      value={refund}
                      onChange={(e) => {
                        const val = e.target.value;
                        // Allow only numbers with up to two decimal places
                        if (val === '' || /^\d+(\.\d{0,2})?$/.test(val)) {
                          setRefund(val);
                        }
                      }}
                      autoComplete="new-refund"
                    />
                  </Form.Group>
                </Col>
                <Col md={6} lg={4} className="mb-3">
                  <Form.Group id="serviceTypeLabel">
                    <RequiredLabel label="Service Type" />
                    <Select
                      options={serviceTypeOptions}
                      placeholder="Select Service Type"
                      className="mb-0"
                      isSearchable={true}
                      value={serviceType}
                      onChange={setServiceType}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12} className="mb-3 mt-3">
                  <Form.Group id="accountTypeOptions">
                    <div className="d-flex justify-content-between">
                      <div className="me-3">
                        <Form.Label className="d-block mb-2">SPAM</Form.Label>
                        <Form.Check
                          type="checkbox"
                          id="spamGlobal"
                          label="Global"
                          name="spamOptions"
                          value="global"
                          checked={selectedOptions.spam.includes("global")}
                          className="mb-1"
                          onChange={() => handleCheckboxChange("spam", "global")}
                        />
                        <Form.Check
                          type="checkbox"
                          id="spamUser"
                          label="User"
                          name="spamOptions"
                          value="user"
                          checked={selectedOptions.spam.includes("user")}
                          onChange={() => handleCheckboxChange("spam", "user")}
                        />
                      </div>
                      <div className="me-3">
                        <Form.Label className="d-block mb-2">Receiver</Form.Label>
                        <Form.Check
                          type="checkbox"
                          id="receiverGlobal"
                          label="Global"
                          name="receiverOptions"
                          value="global"
                          checked={selectedOptions.receiver.includes("global")}
                          className="mb-1"
                          onChange={() => handleCheckboxChange("receiver", "global")}
                        />
                        <Form.Check
                          type="checkbox"
                          id="receiverUser"
                          label="User"
                          name="receiverOptions"
                          value="user"
                          checked={selectedOptions.receiver.includes("user")}
                          onChange={() => handleCheckboxChange("receiver", "user")}
                        />
                      </div>
                      <div className="me-3">
                        <Form.Label className="d-block mb-2">Sender ID</Form.Label>
                        <Form.Check
                          type="checkbox"
                          id="senderGlobal"
                          label="Global"
                          name="senderOptions"
                          value="global"
                          checked={selectedOptions.sender.includes("global")}
                          className="mb-1"
                          onChange={() => handleCheckboxChange("sender", "global")}
                        />
                        <Form.Check
                          type="checkbox"
                          id="senderUser"
                          label="User"
                          name="senderOptions"
                          value="user"
                          checked={selectedOptions.sender.includes("user")}
                          onChange={() => handleCheckboxChange("sender", "user")}
                        />
                      </div>
                      <div className="me-3">
                        <Form.Label className="d-block mb-2">Content ID</Form.Label>
                        <Form.Check
                          type="checkbox"
                          id="contentGlobal"
                          label="Global"
                          name="contentOptions"
                          value="global"
                          checked={selectedOptions.content.includes("global")}
                          className="mb-1"
                          onChange={() => handleCheckboxChange("content", "global")}
                        />
                        <Form.Check
                          type="checkbox"
                          id="contentUser"
                          label="User"
                          name="contentOptions"
                          value="user"
                          checked={selectedOptions.content.includes("user")}
                          onChange={() => handleCheckboxChange("content", "user")}
                        />
                      </div>
                    </div>
                    {validationError && (
                      <div className="invalid-feedback d-block d-block">
                        Please select valid options.
                      </div>
                    )}
                  </Form.Group>
                </Col>

              </Row>
              <Button variant="secondary" className="my-3" type="submit">Preview</Button>
            </Card.Body> */}
          </Form>
        </Card.Body>
      </Card>

        <Modal
          backdrop="static"
          keyboard={false}
          as={Modal.Dialog}
          centered
          show={showDefault}
          onHide={handleClose}
        >
          <Modal.Header>
            <Modal.Title className="h6">User Detail Preview</Modal.Title>
            <Button variant="close" aria-label="Close" onClick={handleClose} />
          </Modal.Header>
          <Modal.Body>
            <Card className="mb-2 mt-2">
              <Row>
                <Col md={10}>
                  <Table
                    responsive
                    className="table-centered table-nowrap rounded mb-0"
                  >
                    <tbody>
                      {/* {loggedUserType !== "enterprise" && (
                        <tr>
                          <td className="border-0">Enterprise Name</td>
                          <td className="border-0">{userType?.label}</td>
                        </tr>
                      )} */}
                      <tr>
                        <td className="border-0">Enterprise User</td>
                        <td className="border-0">{entUser?.label}</td>
                      </tr>
                      <tr>
                        <td className="border-0">System ID</td>
                        <td className="border-0">{enterpriseName}</td>
                      </tr>
                      <tr>
                        <td className="border-0">Department Name</td>
                        <td className="border-0">{name}</td>
                      </tr>
                      <tr>
                        <td className="border-0">Password</td>
                        <td className="border-0">{password}</td>
                      </tr>
                      <tr>
                        <td className="border-0">Route</td>
                        <td className="border-0">{selectedRoute?.label}</td>
                      </tr>
                      <tr>
                        <td className="border-0">Account Type</td>
                        <td className="border-0">
                          {account === "smpp" ? "SMPP" : "-"}
                        </td>
                      </tr>
                      {/* <tr>
                        <td className="border-0">Session</td>
                        <td className="border-0">{session?.label}</td>
                      </tr> */}
                      <tr>
                        <td className="border-0">TPS</td>
                        <td className="border-0">{tps || ""}</td>
                      </tr>
                      {/* <tr>
                        <td className="border-0">Allow API</td>
                        <td className="border-0">{currency ? currency.label : ""}</td>
                      </tr> */}
                      <tr>
                        <td className="border-0">DLT Type</td>
                        <td className="border-0">
                          {dltType ? dltType.label : ""}
                        </td>
                      </tr>
                      {/* <tr>
                        <td colSpan="2" className="border-0 text-center font-weight-bold">COMMERCIAL</td>
                      </tr>
                      <tr>
                        <td className="border-0">Cost</td>
                        <td className="border-0">{currency ? currency.label : ""}</td>
                      </tr>
                      <tr>
                        <td className="border-0">DLT Cost</td>
                        <td className="border-0">{dltType ? dltType.label : ""}</td>
                      </tr> */}
                      {/* <tr>
                        <td className="border-0">Refund</td>
                        <td className="border-0">{currency ? currency.label : ""}</td>
                      </tr>
                      <tr>
                        <td className="border-0">Service Type</td>
                        <td className="border-0">{currency ? currency.label : ""}</td>
                      </tr> */}
                    </tbody>
                  </Table>
                </Col>
                      {copied ? (
                        <Button
                          size="sm"
                          variant="success"
                          className="copy-code-button"
                        >
                          Copied
                        </Button>
                      ) : (
                        <CopyToClipboard
                          text={`Enterprise User: ${
                            entUser?.label
                          }\nSystem ID: ${enterpriseName}\nDepartment Name: ${name}\nPassword: ${password}\n
                         Route: ${selectedRoute?.label}\nAccount Type: ${
                            account === "smpp" ? "SMPP" : "-"}
                          \nTPS: ${
                            tps || ""
                          }\nDLT Type: ${dltType ? dltType.label : ""}`}
                          onCopy={handleCopy}
                        >
                          <Button
                            size="sm"
                            variant="secondary"
                            className="copy-code-button"
                          >
                            Copy
                          </Button>
                        </CopyToClipboard>
                      )}
              </Row>
            </Card>

            <Card className="mb-2 mt-3">
              <Row>
                <Col md={12}>
                  <Card.Body>
                    <b>Share Details:</b>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="emailSwitch"
                        checked={selectedOption === "email"}
                        onChange={() => setSelectedOption("email")}
                      />
                      <FormCheck.Label
                        htmlFor="emailSwitch"
                        style={{ marginLeft: "8px" }}
                      >
                        Email ID
                      </FormCheck.Label>
                    </FormCheck>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="phoneSwitch"
                        checked={selectedOption === "phone"}
                        onChange={() => setSelectedOption("phone")}
                      />
                      <FormCheck.Label
                        htmlFor="phoneSwitch"
                        style={{ marginLeft: "8px" }}
                      >
                        Phone Number
                      </FormCheck.Label>
                    </FormCheck>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="bothSwitch"
                        checked={selectedOption === "both"}
                        onChange={() => setSelectedOption("both")}
                      />
                      <FormCheck.Label
                        htmlFor="bothSwitch"
                        style={{ marginLeft: "8px" }}
                      >
                        Both
                      </FormCheck.Label>
                    </FormCheck>
                    <FormCheck type="switch" className="mt-2">
                      <FormCheck.Input
                        type="checkbox"
                        id="noneSwitch"
                        checked={selectedOption === ""}
                        onChange={() => setSelectedOption("")}
                      />
                      <FormCheck.Label
                        htmlFor="noneSwitch"
                        style={{ marginLeft: "8px" }}
                      >
                        None
                      </FormCheck.Label>
                    </FormCheck>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={submitForm}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      {/* <UserOnboardingListTable key={refreshTable} handleEdit={handleEdit} />  */}
    </>
  );
};
